// import logo from './logo.svg';
import React, { useEffect } from "react";
// import { Button, Flex } from "antd";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/index";
// import { authProtectedRoutes, publicRoutes } from "./routes/index"
import AppRoute from "./routes/route";

import "./App.css";
import NotFoundPage from "./pages/NotFoundPage/index";
import NonAuthLayout from "./components/NonAuthLayout";
import MainLayout from "./components/Layout/index";
// import { isEmpty } from "lodash";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { isEmpty } from "lodash";
// import MainLayout from "./components/Layout/layout";
// import NonAuthLayout from "./pages/NonAuthLayout";

function App(props) {
  const getLayout = () => {
    let layoutCls = MainLayout;

    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = MainLayout;
        break;
      default:
        layoutCls = MainLayout;
        break;
    }
    return layoutCls;
  };

  const Layout = getLayout();

  // const userDetails = localStorage.getItem("sessionUser");

  // console.log(userDetails, "userDetails");

  // const userInfo = !isEmpty(userDetails) ? JSON.parse(userDetails) : "";
  // console.log(userInfo, "userInfo");

  // const userInfoDetails =
  //   !isEmpty(userInfo) &&
  //   userInfo.data &&
  //   userInfo.data.data &&
  //   userInfo.data.data.user
  //     ? userInfo.data.data.user
  //     : "";

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function (position) {
      console.log("Latitude is :", position.coords.latitude);
      console.log("Longitude is :", position.coords.longitude);
    });
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(function (result) {
          console.log(result);
        });
    } else {
      console.log("location not supported by this browser.");
    }
    // if (!isEmpty(userDetails)) {
    //   toast.success("Welcome to pay my trip");
    // }
  }, []);

  return (
    <div className="App">
      {/* <Layout> */}

      <React.Fragment>
        <Router>
          <Switch>
            {authProtectedRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={Layout}
                component={route.component}
                key={idx}
                isAuthProtected={true}
                exact={true}
                // userInfo={userInfoDetails}
                {...route}
              />
            ))}
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={NonAuthLayout}
                // layout={Layout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
                {...route}
              />
            ))}

            <Route path="*" exact component={NotFoundPage} />
          </Switch>
        </Router>
      </React.Fragment>
      {/* </Layout> */}
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      /> */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

App.propTypes = {
  layout: PropTypes.object,
};

export default connect(mapStateToProps, null)(App);
